import { useContext } from "react";
import { ChatControllerContext } from "@/components/chat-widget/chat-context";

export function useChatControllerOptional() {
  return useContext(ChatControllerContext);
}

export function useChatController() {
  const context = useChatControllerOptional();
  if (!context) {
    throw new Error("useChatController must be used within ChatControllerProvider");
  }
  return context;
}
